/**
 * Vertical Oceans — PDP Add-to-cart button loader.
 *
 * Shows the `data-vo-loading` spinner (styled in snippets/buy-buttons-styles.liquid)
 * on the Add-to-cart button while the /cart/add request is in flight and the cart
 * drawer hydrates. The theme's ATC checkmark burst fires on click, not on the
 * network round-trip, so without this the button looks idle during the add.
 *
 * The spinner is keyed to the product form's native `submit` event (not the raw
 * click) so it only appears when the add actually proceeds — the theme rejects
 * clicks for an invalid quantity or unselected variant without submitting, and we
 * don't want a stuck spinner in those cases. It clears on the theme's
 * `shopify:cart:lines-update` (add succeeded) or `shopify:cart:error` (add
 * failed), with a 6s safety timeout so it can never hang.
 *
 * The Buy Now button is handled separately in assets/vo-buy-now.js, which sets the
 * same `data-vo-loading` attribute (and clears it on error / lets it ride until
 * the /checkout redirect).
 */
(function () {
  'use strict';
  if (window.__voPdpLoaderLoaded) return;
  window.__voPdpLoaderLoaded = true;

  var SAFETY_MS = 6000;
  var activeBtn = null;
  var safetyTimer = null;

  function clearLoader() {
    if (activeBtn) activeBtn.removeAttribute('data-vo-loading');
    activeBtn = null;
    if (safetyTimer) {
      clearTimeout(safetyTimer);
      safetyTimer = null;
    }
  }

  function setLoader(btn) {
    clearLoader();
    btn.setAttribute('data-vo-loading', 'true');
    activeBtn = btn;
    safetyTimer = setTimeout(clearLoader, SAFETY_MS);
  }

  // Only show the loader when the product form genuinely submits (add proceeds).
  // event.submitter is the clicked `button[name="add"]`; if absent (e.g. Enter in
  // a non-button field) we skip rather than guess which button to spin.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var submitter = event.submitter;
    if (!(submitter instanceof HTMLElement)) return;
    if (submitter.getAttribute('name') !== 'add') return;
    if (submitter.hasAttribute('disabled')) return;
    setLoader(submitter);
  });

  // Add succeeded / failed / safety timeout.
  document.addEventListener('shopify:cart:lines-update', clearLoader);
  document.addEventListener('shopify:cart:error', clearLoader);
})();